import * as React from 'react';
import classnames from 'classnames';
import styles from 'hellospa/icons/icons.scss';

import { ArrowDirection } from './types';

type Props = React.SVGProps<SVGSVGElement> & {
  direction?: ArrowDirection
};

function ArrowIcon({ direction, ...props }: Props) {
  const transform = React.useMemo(() => {
    switch (direction) {
      case ArrowDirection.Up:
        return 'rotate(-90)';
      case ArrowDirection.Down:
        return 'rotate(90)';
      case ArrowDirection.Right:
        return 'rotate(180)';
      default:
        return 'rotate(0)';
    }
  }, [direction]);

  return (
    <React.Fragment>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 7 12"
        fill="currentColor"
        transform={transform}
        className={classnames(styles.icons, props.className)}
      >
        <path
          d="M6.69246 1.80752C7.10251 1.39403 7.10251 0.723619 6.69246 0.310122C6.28241 -0.103374 5.61759 -0.103374 5.20754 0.310122L0.307538 5.2513C-0.102513 5.6648 -0.102513 6.3352 0.307538 6.7487L5.20754 11.6899C5.61759 12.1034 6.28241 12.1034 6.69246 11.6899C7.10251 11.2764 7.10251 10.606 6.69246 10.1925L2.53492 6L6.69246 1.80752Z" />
      </svg>
    </React.Fragment>
  );
}
export default ArrowIcon;
